var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "DialogReportPaid__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("הוספת הרצאה")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "div",
          { staticClass: "DialogReportPaid__Component__Loading" },
          [
            _c(
              "b-field",
              { attrs: { label: "הזן תאריך התחלה" } },
              [
                _c("FieldInlineDateTime", {
                  attrs: { label: "", position: "is-bottom-left" },
                  model: {
                    value: _vm.model.startTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "startTime", $$v)
                    },
                    expression: "model.startTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "הזן תאריך סיום" } },
              [
                _c("FieldInlineDateTime", {
                  attrs: { label: "", position: "is-bottom-left" },
                  model: {
                    value: _vm.model.endTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "endTime", $$v)
                    },
                    expression: "model.endTime",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "סטטוס" } },
              [
                _c(
                  "b-select",
                  {
                    model: {
                      value: _vm.model.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "status", $$v)
                      },
                      expression: "model.status",
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [_vm._v("1")]),
                    _c("option", { attrs: { value: "0" } }, [_vm._v("0")]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "b-checkbox",
              {
                staticStyle: { "margin-top": "10px" },
                on: { input: _vm.onChange },
                model: {
                  value: _vm.model.isWebinarRegistrationRequired,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "isWebinarRegistrationRequired", $$v)
                  },
                  expression: "model.isWebinarRegistrationRequired",
                },
              },
              [_vm._v(" נדרשת הרשמה לוובינר ")]
            ),
            _c(
              "b-field",
              { attrs: { label: "מזהה לוובינר" } },
              [
                _c("FieldInlineText", {
                  attrs: { type: "number" },
                  model: {
                    value: _vm.model.webinarId,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "webinarId", $$v)
                    },
                    expression: "model.webinarId",
                  },
                }),
              ],
              1
            ),
            _c(
              "b-field",
              { attrs: { label: "קישור לוובינר" } },
              [
                _c("FieldInlineText", {
                  attrs: { readOnly: _vm.model.isWebinarRegistrationRequired },
                  model: {
                    value: _vm.model.webinarUrl,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "webinarUrl", $$v)
                    },
                    expression: "model.webinarUrl",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: {
              loading: _vm.isLoading,
              label: "שמור",
              type: "is-primary",
            },
            on: { click: _vm.save },
          }),
          _c("b-button", {
            attrs: { disabled: _vm.isLoading, label: "סגור" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }